import '../../scss/Footer.scss';
import IconComponent from "../../components/Icons/IconComponent";

const Footer = (props) => {
  const currentYear = new Date().getFullYear();
  return (
    <div>
      <div className="footer">
        {currentYear} Tradeview® IB Portal V1.3.27 &nbsp;&nbsp;For more information visit:&nbsp;<a href="https://www.tradeviewmarkets.com/" target="_blank">www.tradeviewmarkets.com</a>
      </div>
    </div>
  );
};

export default Footer;